<template>
  <div>
    <orders-table></orders-table>
    <router-view />
  </div>
</template>

<script>
import OrdersTable from "./OrdersTable";

export default {
  name: "OrdersView",
  components: {
    "orders-table": OrdersTable,
  },
  mounted() {},
  data() {
    return {};
  },
};
</script>
